import React from 'react'
import {useLocation} from 'react-router-dom'
function Tags(props) {
    const location=useLocation()
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "5px 2%",
            background: "rgba(227, 218, 227, 0.2)",
            borderRadius: "8px",
            flex: 1,
            padding: 0,
            fontFamily:"AvenirNextBold !important",
            justifyContent:"center",
            height:90
        }}>
            <div>
            <div style={{ height: 15, width: 15, borderLeft: "2px solid #693668", borderTop: "2px solid #693668", transform: "translateY(6px) rotate(45deg)",marginTop: "8px" }}></div>
            </div>
            <div><span style={{ fontSize: "20px",
            lineheight: "21px",
            color: "#693668",
            fontWeight: "bold",
            fontFamily:"AvenirNextBold !important"}}>{props.number !== undefined ? props.number : 0}</span></div>
            <div style={{
                    position: "relative",
                    transform: "translateY(-7px)"
            }}><span style={{
                fontWeight: "bold",
                fontSize: "22px",
                lineheight: "21px",
                color: "#693668",
                fontFamily:"AvenirNextBold !important"
            }}>{props.type}</span></div>
        </div>
    )
}

export default Tags
